module.exports = __webpack_public_path__ + "img/Equipment.be146d38.svg";